import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';
import { TenantCreationComponent } from './tenant-creation/tenant-creation.component';
import { TenantGridComponent } from './tenant-grid/tenant-grid.component';

const routes: Routes = [
  {
    path: 'tenant-creation',
    component: TenantCreationComponent,
    canDeactivate: [UnSavedChangesRouteGuard]
  },
  {
    path: '',
    component: TenantGridComponent
  }];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantConfigurationRoutingModule { }
